import { Link } from 'react-router-dom';

const services = [
  { label: 'Carpet Installation', href: '/services' },
  { label: 'Tile & Stone Flooring', href: '/services' },
  { label: 'Luxury Vinyl Plank (LVP)', href: '/services' },
  { label: 'Area Rugs', href: '/services' },
  { label: 'Showroom Consultation', href: '/services' },
];

const pages = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About Us', href: '/about' },
  { label: 'Brooklyn', href: '/brooklyn' },
];

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#F0EBE3' }} className="border-t border-warmgray">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center mb-4 cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/ae54e299-3d8f-4b74-b625-e71d46fd0431/adfc3f16-7512-45a0-8f44-f4a59616e357_boro-logo.jpg?v=cb643541d58765e39496b98c07e6a725"
                alt="Boro Rug & Flooring Logo"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed mb-5">
              Brooklyn&apos;s premier flooring showroom and installation company. Premium carpet, tile, stone, vinyl, and area rugs since 1998.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-warmgray rounded-full hover:bg-bronze hover:text-white transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-warmgray rounded-full hover:bg-bronze hover:text-white transition-colors cursor-pointer">
                <i className="ri-facebook-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-warmgray rounded-full hover:bg-bronze hover:text-white transition-colors cursor-pointer">
                <i className="ri-yelp-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-base font-semibold text-charcoal mb-5">Our Services</h4>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.label}>
                  <Link
                    to={s.href}
                    className="text-sm text-gray-500 hover:text-bronze transition-colors cursor-pointer"
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-serif text-base font-semibold text-charcoal mb-5">Pages</h4>
            <ul className="space-y-2.5">
              {pages.map((p) => (
                <li key={p.label}>
                  <Link
                    to={p.href}
                    className="text-sm text-gray-500 hover:text-bronze transition-colors cursor-pointer"
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-base font-semibold text-charcoal mb-5">Contact & Showroom</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-bronze text-sm"></i>
                </div>
                <span className="text-sm text-gray-500">1247 Flatbush Ave<br />Brooklyn, NY 11226</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-bronze text-sm"></i>
                </div>
                <a href="tel:+17185550100" className="text-sm text-gray-500 hover:text-bronze transition-colors cursor-pointer">
                  (718) 555-0100
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-bronze text-sm"></i>
                </div>
                <a href="mailto:info@bororu.com" className="text-sm text-gray-500 hover:text-bronze transition-colors cursor-pointer">
                  info@bororu.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-bronze text-sm"></i>
                </div>
                <span className="text-sm text-gray-500">Mon–Fri: 9am – 6pm<br />Sat: 10am – 5pm · Sun: Closed</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-warmgray">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">
            &copy; {new Date().getFullYear()} Boro Rug &amp; Flooring. All rights reserved. Brooklyn, NY.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-gray-400 hover:text-bronze cursor-pointer transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-400 hover:text-bronze cursor-pointer transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
